import CognitoAuthProvider from './CognitoAuthProvider';

export default CognitoAuthProvider;
